export default __webpack_public_path__ + "static/media/arrowLeft.27a5109e.svg";